"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeLikedCounter = initializeLikedCounter;
class LikedCounter {
    constructor(likeStorage, counterIcons) {
        this.likeStorage = likeStorage;
        this.counterElements = this.addCounterToIcon(counterIcons);
        this.updateCounter();
    }
    addCounterToIcon(counterIcons) {
        const icons = counterIcons.map((counterIcon) => {
            counterIcon.innerHTML += this.getLikeIconMarkup();
            return counterIcon.querySelector('[data-js-like-counter]');
        });
        return icons;
    }
    updateCounter() {
        const likedPostsLength = Object.keys(this.likeStorage.get()).length;
        this.counterElements.forEach((counterElement) => {
            if (counterElement) {
                counterElement.innerHTML = likedPostsLength.toString();
            }
            if (likedPostsLength === 0) {
                counterElement === null || counterElement === void 0 ? void 0 : counterElement.classList.add('u-display--none');
            }
            else {
                counterElement === null || counterElement === void 0 ? void 0 : counterElement.classList.remove('u-display--none');
            }
        });
    }
    getLikeIconMarkup() {
        return '<span class="u-display--none like-counter" data-js-like-counter></span>';
    }
}
exports.default = LikedCounter;
function initializeLikedCounter(likeStorage) {
    const counterIcons = document.querySelectorAll('[data-js-like-icon-counter]');
    if (counterIcons.length === 0) {
        return;
    }
    ;
    const likeCounterInstance = new LikedCounter(likeStorage, [...counterIcons]);
    window.addEventListener('likedPostsLengthUpdated', (e) => {
        likeCounterInstance.updateCounter();
    });
}
